// テンプレート操作
import {
    SETING_MENU_PREMIUM_PUT,
    SETING_MENU_PREMIUM_GET,
    SETING_MENU_PREMIUM_PUT_LOADING,
    SETING_MENU_PREMIUM_POST,
    SETING_MENU_PREMIUM_GET_ALL,
    SETING_MENU_PREMIUM_DELETE,
    SETING_MENU_PREMIUM_SORT,
    SETTING_MENU_PREMIUM_RATIO_SETTING
} from '../constants/ActionTypes'
import { glasConfig } from '../constants/Config'
import request from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

const resultSuccess = (type, data) => {
    return {
        type: type,
        data,
    }
}

//テンプレート登録
export const postMenuPremium = (params) => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .post(glasConfig.url_base + glasConfig.path_menu_premium, params, {
                headers: {
                    Authorization: localStorage.getItem('token'),
                },
            })
            .then((response) => {
                dispatch(hideLoading())
                if (response.data.code === 0) {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_POST, params))
                } else {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_POST, {}))
                }
                return response.data;
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETING_MENU_PREMIUM_POST, error)
                throw error
            })
    }
}

// テンプレート取得
export const getAllMenuPremium = () => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .get(glasConfig.url_base + glasConfig.path_menu_premium + 'all', {
                headers: {
                    Authorization: localStorage.getItem('token'),
                },
            })
            .then((response) => {
                dispatch(hideLoading())
                if (response.data.code === 0) {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_GET_ALL, response.data.data))
                } else {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_GET_ALL, []))
                }
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETING_MENU_PREMIUM_GET_ALL, error)
                throw error
            })
    }
}

// テンプレート更新
export const putMenuPremium = (params, id) => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .put(glasConfig.url_base + glasConfig.path_menu_premium + id, params, {
                headers: {
                    Authorization: localStorage.getItem('token'),
                },
            })
            .then((response) => {
                dispatch(hideLoading())
                if (response.data.code === 0) {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_PUT, params))
                } else {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_PUT, {}))
                }
                return response.data;
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETING_MENU_PREMIUM_PUT, error)
                throw error
            })
    }
}


export const dragMenuPremium = (params) => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .post(
                glasConfig.url_base + glasConfig.path_menu_premium + 'sort',params,
                {
                    headers: {
                        Authorization: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                dispatch(hideLoading())
                if (response.data.code === 0) {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_SORT, params))
                } else {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_SORT, {}))
                }
                return response.data;
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETING_MENU_PREMIUM_SORT, error)
                throw error
            })
    }
}

// テンプレート削除
export const deleteMenuPremium = (id) => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .delete(
                glasConfig.url_base + glasConfig.path_menu_premium + id,
                {
                    headers: {
                        Authorization: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                dispatch(hideLoading())
                if (response.data.code === 0) {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_DELETE, id))
                } else {
                    dispatch(resultSuccess(SETING_MENU_PREMIUM_DELETE, {}))
                }
                return response.data;
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETING_MENU_PREMIUM_DELETE, error)
                throw error
            })
    }
}


export const getPointRadioSetting = () => {
    return (dispatch) => {
        dispatch(showLoading())
        return request
            .get(
                glasConfig.url_base + glasConfig.path_menu_premium + 'ratiosetting',
                {
                    headers: {
                        Authorization: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                dispatch(hideLoading())
                if (response.data.code === 0) {
                    dispatch(resultSuccess(SETTING_MENU_PREMIUM_RATIO_SETTING, response.data.data))
                } else {
                    dispatch(resultSuccess(SETTING_MENU_PREMIUM_RATIO_SETTING, {}))
                }
                return response.data;
            })
            .catch((error) => {
                dispatch(hideLoading())
                console.log('error on call ' + SETTING_MENU_PREMIUM_RATIO_SETTING, error)
                throw error
            })
    }
}

